export default __webpack_public_path__ + "static/media/gift.6c17f892.svg";